<template>
  <div class="hue-picker">
    <p v-if="label" class="block-label">{{ label }}</p>

    <div class="color-box">
      <div class="color-box__swatch" :style="{ backgroundColor: hex }" />
    </div>

    <div class="hue-slider">
      <hue :value="{ hsl: hsl }" @change="onHueChange" />
    </div>

    <div v-if="palettePreview">
      <p class="palette-label">{{ adminText(&quot;shellAll.color_palette_preview&quot;, &quot;Color palette preview&quot;) }}</p>
      <div class="palette">
        <div
          v-for="(swatch, index) in palette"
          :key="index"
          class="palette__swatch"
          :style="{ backgroundColor: swatch }"
        />
      </div>
    </div>

    <p v-if="hint" class="hint">{{ hint }}</p>
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { Hue } from 'vue-color'

import { DEFAULT_HUE, getBrandColor, getBrandPalette, hexToHue } from '@/utils/color'

export default {
  mixins: [AdminContext],
  name: 'hue-picker-field',
  components: {
    Hue,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    hint: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
    palettePreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hue() {
      const hue = hexToHue(this.value)

      return hue === null ? DEFAULT_HUE : hue
    },
    hex() {
      return getBrandColor(this.hue)
    },
    hsl() {
      // The vue-color Hue slider only reads `h` off this object to place its pointer.
      return { h: this.hue, s: 1, l: 0.5, a: 1 }
    },
    palette() {
      return getBrandPalette(this.hue)
    },
  },
  created() {
    /*
      Events saved with the old free-form picker can hold any saturation/brightness.
      Normalise on mount so the stored value always matches the swatch on screen.
    */
    if (this.value !== this.hex) this.$emit('input', this.hex)
  },
  methods: {
    onHueChange({ h }) {
      this.$emit('input', getBrandColor(Math.round(h)))
    },
  },
}
</script>

<style scoped>
.hue-picker {
  display: flex;
  flex-direction: column;
}

.block-label {
  font-family: 'Raleway', sans-serif;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.2;
  letter-spacing: -0.24px;
  color: #333333;
  margin-bottom: 16px;
}

.color-box {
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  background-color: #ffffff;
  height: 64px;
  padding: 8px;
}

.color-box__swatch {
  height: 100%;
  width: 100%;
  border-radius: 4px;
}

.hue-slider {
  position: relative;
  height: 16px;
  margin-top: 12px;
  border-radius: 8px;
  overflow: hidden;
}

.palette-label {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #666666;
  margin: 16px 0 12px;
}

.palette {
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  padding: 10px;
  overflow: hidden;
}

.palette__swatch {
  height: 36px;
}

.palette__swatch:first-child {
  border-radius: 4px 4px 0 0;
}

.palette__swatch:last-child {
  border-radius: 0 0 4px 4px;
}

.hint {
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 14px;
  line-height: 1.2;
  color: #979797;
  margin: 12px 0 0;
}
</style>
